import axios from "@/plugins/axios";

let url = "/api/v1/apply/applications";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    getEquipments(data){
        return axios.get(`${url}/equipments`, data).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
